import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();

export const routes = [
    {
        path: '/',
        name: 'widgets',
        meta: { title: t('formychat_widgets') },
        component: () => import('@/WidgetList.vue'),
    },
    {
        path: '/start',
        name: 'start',
        meta: { title: t('get_started_with_formychat') },
        component: () => import('@/EmptyWidget.vue'),
    },
    {
        path: '/widget/:widgetId',
        name: 'widget.edit',
        meta: { title: t('edit_widget') },
        component: () => import('@/edit-widget/Main.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
    }
]

